<template>
  <div>
    <cube-popup
      v-show="visible"
      type="my-popup"
      :center="false"
      position="right"
      class="filter-wrap"
    >
      <div class="title-div">
        <span class="title">{{ $t('message["1073"]') }}</span>
      </div>
      <div class="time-range-div">
        <div
          class="start-div"
          @click="showDatePicker('0')"
        >
          <i class="iconfont iconicon-test26 timeIcon" />
          <input
            v-model="startDate"
            class="input-text-time"
            :placeholder="timeStarPlace"
            type="text"
            readonly="readonly"
          >
          <i
            v-if="startDate"
            class="iconfont iconicon-test28 rawRight"
            @click="handleClearStart"
          />
          <i
            v-else
            class="iconfont iconicon-test18 rawRight"
          />
        </div>
        <div
          class="end-div"
          @click="showDatePicker('1')"
        >
          <i class="iconfont iconicon-test26 timeIcon" />
          <input
            v-model="endDate"
            type="text"
            :placeholder="timeEndPlace"
            class="input-text-time"
            readonly="readonly"
          >
          <i
            v-if="endDate"
            class="iconfont iconicon-test28 rawRight"
            @click="handleClearEnd"
          />
          <i
            v-else
            class="iconfont iconicon-test18 rawRight"
          />
        </div>
      </div>
      <div class="operate-btn-div">
        <input
          type="button"
          class="cancel"
          :value="cancelTxt"
          @click="onCancel"
        >
        <input
          type="button"
          class="confirm"
          :value="okTTxt"
          @click="onSave"
        >
      </div>
    </cube-popup>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      startDate: '',
      endDate: '',
      timeFlag: '0'
    }
  },
  computed: {
    timeEndPlace () {
      return this.$t('message["870"]')
    },
    timeStarPlace () {
      return this.$t('message["872"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    }
  },
  methods: {
    showDatePicker (flag) {
      this.timeFlag = flag
      if (!this.datePicker) {
        let arr = []
        let min = null
        let max = null
        let value = null
        if (flag === '0') {
          if (this.startDate) {
            min = new Date(2000, 1, 1)
            if (this.endDate) {
              arr = this.endDate.split('-')
              max = new Date(arr[0] * 1, arr[1] * 1 - 1, arr[2] * 1)
            } else {
              max = new Date(2200, 1, 1)
            }
            arr = this.startDate.split('-')
            value = new Date(arr[0] * 1, arr[1] * 1 - 1, arr[2] * 1)
          } else {
            value = new Date()
            min = new Date(2000, 1, 1)
            if (this.endDate) {
              arr = this.endDate.split('-')
              max = new Date(arr[0] * 1, arr[1] * 1 - 1, arr[2] * 1)
            } else {
              max = new Date(2200, 1, 1)
            }
          }
        } else {
          max = new Date(2200, 1, 1)
          if (this.startDate) {
            arr = this.startDate.split('-')
            min = new Date(arr[0] * 1, arr[1] * 1 - 1, arr[2] * 1)
          } else {
            min = new Date(2000, 1, 1)
          }
          if (this.endDate) {
            arr = this.endDate.split('-')
            value = new Date(arr[0] * 1, arr[1] * 1 - 1, arr[2] * 1)
          } else {
            value = new Date()
          }
        }
        this.datePicker = this.$createDatePicker({
          title: this.$t('message["1076"]'),
          min: min,
          max: max,
          value: value,
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.datePicker.show()
    },
    selectHandle (date, selectedVal, selectedText) {
      if (this.timeFlag === '0') {
        this.startDate = selectedVal.join('-')
      } else {
        this.endDate = selectedVal.join('-')
      }
      this.datePicker = null
    },
    cancelHandle () {
      this.datePicker = null
    },
    handleClearStart () {
      this.startDate = ''
    },
    handleClearEnd () {
      this.endDate = ''
    },
    onCancel () {
      this.startDate = ''
      this.endDate = ''
      this.$emit('update:visible', false)
    },
    onSave () {
      const data = {
        starttime: this.startDate,
        endtime: this.endDate
      }
      this.startDate = ''
      this.endDate = ''
      this.$emit('timeSelectChange', data)
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrap::v-deep {
  .title-div {
    width: 375px;
    height: 44px;
    margin-top: 12px;
    .title {
      font-size: 14px;
      height: 44px;
      line-height: 44px;
      margin-left: 12px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
  }

  .start-div,
  .end-div {
    height: 48px;
    background-color: #fff;
    border-bottom: solid 1px rgba(219, 219, 219, 1);
  }
  .timeIcon {
    margin-left: 15px;
    width: 14px;
    height: 16px;
    margin-right: 4px;
    margin-top: -4px;
    color: rgba(80, 119, 170, 1);
  }
  .rawRight {
    font-size: 20px;
    color: #cccccc;
    margin-left: 40px;
  }
  .input-text-time {
    height: 24px;
    width: 240px;
    border: none;
    outline: none;
    margin-top: 12px;
  }
  .cancel {
    width: 176px;
    height: 46px;
    margin-left: 8px;
    margin-top: 8px;
    outline: none;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(219, 219, 219, 1);
  }
  .confirm {
    width: 176px;
    margin-left: 8px;
    height: 46px;
    margin-top: 8px;
    background: linear-gradient(
      360deg,
      rgba(80, 119, 170, 1) 0%,
      rgba(96, 143, 204, 1) 100%
    );
    outline: none;
    color: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    border: 1px solid rgba(80, 119, 170, 1);
  }
  .operate-btn-div {
    height: 62px;
    width: 375px;
    background-color: #fff;
    position: fixed;
    bottom: 0px;
  }
}
</style>
